// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#8e65ff","colorPrimaryLight5":"#c7b2ff","colorPrimaryLight7":"#ddd1ff","colorPrimaryLight9":"#f4f0ff"};